export default (name: string, err: any) => `Failed to start ${name}. ${typeof err === "string" ? err : err?.message}`;
